var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"location-picker-container"},[_c('div',{ref:"ggMap",staticClass:"gg-map"}),_c('img',{staticClass:"map-pin",attrs:{"src":require("@/assets/icons/google-pin.png"),"alt":"pin"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }